import store from "../store/store";

export default {
  install(Vue, options) {
    Vue.prototype.$loading = () => store.commit("SHOW_LOADING");
    Vue.prototype.$hideLoading = () => store.commit("HIDE_LOADING");
  }
};
